import { useSelector } from 'react-redux';
import reducerRegistry from '@comeon/reducer-registry';

const UPDATE_FRAME = '@komigen/mobile-frontend/analytics/UPDATE_FRAME';
const REDUCER_NAME = 'analytics';

const selectAnalytics = state => state.analytics;

function GetFrame() {
	const analytics = useSelector(selectAnalytics);
	return analytics.frame ? analytics.frame : 'site';
}

function updateFrame(frame, dispatch) {
	dispatch({
		type: UPDATE_FRAME,
		payload: {
			frame
		}
	});
}

function reducer(state = {}, { type, payload }) {
	if (type === UPDATE_FRAME) {
		return {
			...state,
			...payload
		};
	}
	return state;
}

reducerRegistry.register(REDUCER_NAME, reducer);

export default reducer;
export { updateFrame, GetFrame };
